import BxApi from "./bx-api";

export default BxApi;
